import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService } from 'app/core/services/user.service';
import { AccountService } from 'app/core/services/account.service';
import { AuthorizationGuard } from 'app/core/services/authorization-guard.service';
import { SortService } from 'app/core/services/sort.service';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [],
    providers: [
        UserService,
        AccountService,
        AuthorizationGuard,
        SortService
    ]
})
export class CoreModule { }
